/**
 * computeSyncAction (868m55n4x) decides which of a switch/router row's
 * three sync actions applies, branching on pollMode first -- same
 * precedent as computeSyncStatusBadge (switchStatusBadge.js), extracted
 * here because MdSwitches.jsx's own version of this branch never checked
 * pollMode at all: a CONTROLLER-mode, never-synced device (e.g. a UniFi AP
 * reached only through its controller, no agent involved) fell into the
 * NEVER_SYNCED branch and called the AGENT-only start-monitoring endpoint,
 * which never reaches an agent and does nothing.
 *
 * 'controller' and 'forcePoll' intentionally point at the same underlying
 * action: the backend's poll endpoint already branches CONTROLLER-vs-AGENT
 * internally (switch.routes.cjs), so both just trigger the same POST
 * .../poll call, one labeled "Sync from controller", the other "Force
 * Poll". Only 'startMonitoring' is a genuinely different, AGENT-only
 * endpoint.
 *
 * Note: MdSwitchDetail.jsx does not import this file (or its sibling
 * switchStatusBadge.js) -- it has its own, separately-written pollMode
 * branch for both the badge and these buttons. This helper stops
 * MdSwitches.jsx's three-way branch from drifting further out of sync with
 * MdSwitchDetail.jsx's, but does not fully close the duplication the badge
 * helper already left open.
 *
 * @param {{ pollMode?: string, pollStatus?: string }} row
 * @returns {'controller'|'startMonitoring'|'forcePoll'}
 */
export function computeSyncAction({ pollMode, pollStatus }) {
  if (pollMode === 'CONTROLLER') return 'controller';
  if (pollStatus === 'NEVER_SYNCED') return 'startMonitoring';
  return 'forcePoll';
}
